import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from './ui/button';

export default function AdminUnlicensed() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
      <div className="max-w-md w-full p-10 text-center rounded-lg border border-slate-200 bg-white shadow-sm">
        <ShieldAlert className="mx-auto text-rose-600" size={48} />
        <h1 className="text-3xl font-semibold text-slate-900 mt-4">Panel no licenciado</h1>
        <p className="text-slate-600 text-sm mt-3">
          El acceso al panel de administración está desactivado. Contacta al administrador de plataforma.
        </p>
        <Button asChild variant="outline" className="mt-6">
          <Link to="/admin/login">Volver al login</Link>
        </Button>
      </div>
    </div>
  );
}
